import PropTypes from 'prop-types'

const Counter = ({ count, truncate }) => (truncate && count > 9 && '9+') || count

Counter.defaultProps = {
  count: 0,
  truncate: false,
}

Counter.propTypes = {
  /**
   * The number to render.
   */
  count: PropTypes.number,
  /**
   * Whether the number rendered should be truncated if greater than 9 (displays `9+`)
   */
  truncate: PropTypes.bool,
}

export default Counter
